// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this at the top of your CSS file to ensure it overrides other styles */

body, html, #root, .app {
  background-color: #ded8d1 !important;
}

body {
  background-color: #ded8d1;
  margin: 0;
  padding: 0;
}

/* Set Crimson Text font globally for the vault component */
.vault-container,
.vault-container *,
.vault-container input,
.vault-container button,
.vault-container select,
.vault-container textarea {
  font-family: 'Crimson Text', serif !important;
}

.vault-container {
  width: 80%;
  min-height: 100vh;
  margin: 0 auto;
  padding: 2rem;
  box-sizing: border-box;
}

.vault-header {
  text-align: center;
  margin-bottom: 2rem;
}

.vault-header h1,
.vault-header p {
  font-family: 'Crimson Text', serif;
}

.vault-search {
  margin-bottom: 2rem;
}

.vault-search input {
  font-family: 'Crimson Text', serif;
}

/* Form elements */
.vault-new-entry {
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.vault-sidebar {
  width: 100%;
  height: 100%;
}

.vault-select {
  width: 100%;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #eaeaea;
  background-color: #fff;
  font-size: 14px;
  font-family: 'Crimson Text', serif;
}

.vault-textarea {
  width: 100%;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #eaeaea;
  background-color: #fff;
  font-size: 14px;
  font-family: 'Crimson Text', serif;
  resize: vertical;
}

.empty-vault {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  width: 100%;
  border: 2px dashed #eaeaea;
  border-radius: 8px;
}

.items-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1.5rem;
}

/* Responsive adjustments */
@media (max-width: 1600px) {
  .items-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 1200px) {
  .items-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .items-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .items-grid {
    grid-template-columns: 1fr;
  }
  
  .card-outer-frame {
    max-width: 320px;
    margin: 0 auto 1.5rem;
  }
}

.card-outer-frame {
  width: 280px;
  height: 400px;
  background-color: #EEE8d8;
  border-radius: 18px;
  padding: 6px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.3), 0 2px 4px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 1.5rem;
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.card-outer-frame:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.3);
}

/* New Card Styling */
.card-body {
  border-radius: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.card-rules-text-box {
  margin: 5px;
  padding: 8px;
  border-radius: 5px;
  font-family: 'Crimson Text', serif;
  font-size: 0.8em;
  flex-grow: 1;
  overflow-y: auto;
  line-height: 1;
  min-height: 180px;
}

.card-source {
  font-family: 'Crimson Text', serif;
  font-style: italic;
  font-size: 0.8em;
  color: #666666;
  text-align: center;
  border-top: 1px solid rgba(0,0,0,0.1);
  padding: 2px 0; /* Reduced padding */
  margin-top: 2px; /* Minimal top margin */
  margin-bottom: 0; /* No bottom margin */
}

/* Card Color Specific Styling */
.card-body.color-green {
  background: linear-gradient(135deg, #3A6B35 0%, #2A5225 100%);
  border-color: #4A7F45;
}
.card-body.color-black {
  background: linear-gradient(135deg, #403634 0%, #2C2524 100%);
  border-color: #5A504D;
}
.card-body.color-blue {
  background: linear-gradient(135deg, #2A5A7A 0%, #1E4058 100%);
  border-color: #477C9E;
}
.card-body.color-red {
  background: linear-gradient(135deg, #8C3A3A 0%, #6E2B2B 100%);
  border-color: #A65757;
}
.card-body.color-white {
  background: linear-gradient(135deg, #E0DBCF 0%, #C8C4B9 100%);
  border-color: #D4D0C5;
}
.card-body.color-neutral {
  background: linear-gradient(135deg, #8C8C8C 0%, #6E6E6E 100%);
  border-color: #A0A0A0;
}
.card-body.color-special {
  background: linear-gradient(135deg, #A89070 0%, #8A7458 100%);
  border-color: #BCA888;
}
.card-body.color-multi {
  background: linear-gradient(135deg, #B08D57 0%, #8C6D3F 100%);
  border-color: #C09F6F;
}

.card-header-section {
  padding: 8px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(0,0,0,0.1);
  border-bottom: 1px solid rgba(0,0,0,0.2);
  min-height: 30px;
}
.card-body.color-white .card-header-section .card-name,
.card-body.color-white .card-header-section .card-cost { color: #2c2c2c; }

.card-body:not(.color-white) .card-header-section .card-name,

.card-name {
  font-family: 'Crimson Text', serif;
  font-size: 1.2em;
  font-weight: 600;
}

.card-image-area {
  width: calc(100% - 16px);
  height: 130px;
  margin: 6px auto 0;
  background-color: #444;
  border: 2px solid rgba(0,0,0,0.3);
  border-radius: 4px;
  overflow: hidden;
}

.card-image-area img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.card-type-bar {
  padding: 5px 12px;
  margin: 6px 8px 0 8px;
  border-radius: 4px;
  font-size: 0.8em;
  font-family: 'Crimson Text', serif;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(0,0,0,0.1);
  border-top: 1px solid rgba(0,0,0,0.15);
  border-bottom: 1px solid rgba(0,0,0,0.15);
}
.card-body.color-white .card-type-bar { color: #2c2c2c; }
.card-body:not(.color-white) .card-type-bar { color: #f0f0f0; }

.card-rules-text-box p {
  margin: 0 0 8px 0;
}
.card-rules-text-box p:last-child {
  margin-bottom: 0;
}
.card-flavor-text {
  font-family: 'Crimson Text', serif;
  font-style: italic;
  font-size: 1em;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid rgba(0,0,0,0.15);
}

.card-actions {
  position: absolute;
  bottom: 15px;
  right: 15px;
  display: flex;
  gap: 8px;
}

/* Modal styling */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.edit-modal {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

@media (max-width: 768px) {
  .vault-container {
    padding: 1rem;
  }
  
  .items-grid {
    grid-template-columns: 1fr;
  }
  
  .card-outer-frame {
    width: 100%;
    max-width: 320px;
    margin: 0 auto 1.5rem;
  }
}

/* Minimalist theme styles */
.card-body.minimalist {
  background: #f9f6ed;
  border: none;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.card-body.minimalist .card-header-section {
  background-color: #eee8d8;
  border-bottom: 1px solid #e0d9c8;
}

.card-body.minimalist .card-name {
  color: #000000;
}

.card-body.minimalist .card-type-bar {
  background-color: #eee8d8;
  color: #333333;
  border-color: #e0d9c8;
}

.card-body.minimalist .card-rules-text-box {
  background-color: #f5f1e6;
  color: #333333;
  border: 1px solid #e0d9c8;
}

/* Add card styles */
.add-card {
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.add-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.3);
}

.add-card-body {
  background: #f9f6ed !important;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.add-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-icon svg {
  opacity: 0.6;
}

.add-card:hover .add-icon {
  background-color: rgba(0,0,0,0.1);
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Vault/Vault.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE,oCAAoC;AACtC;;AAIA;EACE,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA,2DAA2D;AAC3D;;;;;;EAME,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,iEAAiE;EACjE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,cAAc,EAAE,oBAAoB;EACpC,eAAe,EAAE,uBAAuB;EACxC,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA,gCAAgC;AAChC;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;AACA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,wCAAwC;EACxC,gBAAgB;AAClB;AACA;yDACyD,cAAc,EAAE;;AAEzE;;;EAGE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,sCAAsC;EACtC,yCAAyC;AAC3C;AACA,wCAAwC,cAAc,EAAE;AACxD,8CAA8C,cAAc,EAAE;;AAE9D;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":["/* Add this at the top of your CSS file to ensure it overrides other styles */\n\nbody, html, #root, .app {\n  background-color: #ded8d1 !important;\n}\n\n@import url('https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n\nbody {\n  background-color: #ded8d1;\n  margin: 0;\n  padding: 0;\n}\n\n/* Set Crimson Text font globally for the vault component */\n.vault-container,\n.vault-container *,\n.vault-container input,\n.vault-container button,\n.vault-container select,\n.vault-container textarea {\n  font-family: 'Crimson Text', serif !important;\n}\n\n.vault-container {\n  width: 80%;\n  min-height: 100vh;\n  margin: 0 auto;\n  padding: 2rem;\n  box-sizing: border-box;\n}\n\n.vault-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.vault-header h1,\n.vault-header p {\n  font-family: 'Crimson Text', serif;\n}\n\n.vault-search {\n  margin-bottom: 2rem;\n}\n\n.vault-search input {\n  font-family: 'Crimson Text', serif;\n}\n\n/* Form elements */\n.vault-new-entry {\n  margin-bottom: 2rem;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.vault-sidebar {\n  width: 100%;\n  height: 100%;\n}\n\n.vault-select {\n  width: 100%;\n  padding: 8px;\n  border-radius: 5px;\n  border: 1px solid #eaeaea;\n  background-color: #fff;\n  font-size: 14px;\n  font-family: 'Crimson Text', serif;\n}\n\n.vault-textarea {\n  width: 100%;\n  padding: 8px;\n  border-radius: 5px;\n  border: 1px solid #eaeaea;\n  background-color: #fff;\n  font-size: 14px;\n  font-family: 'Crimson Text', serif;\n  resize: vertical;\n}\n\n.empty-vault {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  width: 100%;\n  border: 2px dashed #eaeaea;\n  border-radius: 8px;\n}\n\n.items-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 1.5rem;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1600px) {\n  .items-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 1200px) {\n  .items-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .items-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 576px) {\n  .items-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .card-outer-frame {\n    max-width: 320px;\n    margin: 0 auto 1.5rem;\n  }\n}\n\n.card-outer-frame {\n  width: 280px;\n  height: 400px;\n  background-color: #EEE8d8;\n  border-radius: 18px;\n  padding: 6px;\n  box-shadow: 0 6px 16px rgba(0,0,0,0.3), 0 2px 4px rgba(0,0,0,0.2);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-bottom: 1.5rem;\n  cursor: pointer;\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.card-outer-frame:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0,0,0,0.3);\n}\n\n/* New Card Styling */\n.card-body {\n  border-radius: 12px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.card-rules-text-box {\n  margin: 5px;\n  padding: 8px;\n  border-radius: 5px;\n  font-family: 'Crimson Text', serif;\n  font-size: 0.8em;\n  flex-grow: 1;\n  overflow-y: auto;\n  line-height: 1;\n  min-height: 180px;\n}\n\n.card-source {\n  font-family: 'Crimson Text', serif;\n  font-style: italic;\n  font-size: 0.8em;\n  color: #666666;\n  text-align: center;\n  border-top: 1px solid rgba(0,0,0,0.1);\n  padding: 2px 0; /* Reduced padding */\n  margin-top: 2px; /* Minimal top margin */\n  margin-bottom: 0; /* No bottom margin */\n}\n\n/* Card Color Specific Styling */\n.card-body.color-green {\n  background: linear-gradient(135deg, #3A6B35 0%, #2A5225 100%);\n  border-color: #4A7F45;\n}\n.card-body.color-black {\n  background: linear-gradient(135deg, #403634 0%, #2C2524 100%);\n  border-color: #5A504D;\n}\n.card-body.color-blue {\n  background: linear-gradient(135deg, #2A5A7A 0%, #1E4058 100%);\n  border-color: #477C9E;\n}\n.card-body.color-red {\n  background: linear-gradient(135deg, #8C3A3A 0%, #6E2B2B 100%);\n  border-color: #A65757;\n}\n.card-body.color-white {\n  background: linear-gradient(135deg, #E0DBCF 0%, #C8C4B9 100%);\n  border-color: #D4D0C5;\n}\n.card-body.color-neutral {\n  background: linear-gradient(135deg, #8C8C8C 0%, #6E6E6E 100%);\n  border-color: #A0A0A0;\n}\n.card-body.color-special {\n  background: linear-gradient(135deg, #A89070 0%, #8A7458 100%);\n  border-color: #BCA888;\n}\n.card-body.color-multi {\n  background: linear-gradient(135deg, #B08D57 0%, #8C6D3F 100%);\n  border-color: #C09F6F;\n}\n\n.card-header-section {\n  padding: 8px 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: rgba(0,0,0,0.1);\n  border-bottom: 1px solid rgba(0,0,0,0.2);\n  min-height: 30px;\n}\n.card-body.color-white .card-header-section .card-name,\n.card-body.color-white .card-header-section .card-cost { color: #2c2c2c; }\n\n.card-body:not(.color-white) .card-header-section .card-name,\n\n.card-name {\n  font-family: 'Crimson Text', serif;\n  font-size: 1.2em;\n  font-weight: 600;\n}\n\n.card-image-area {\n  width: calc(100% - 16px);\n  height: 130px;\n  margin: 6px auto 0;\n  background-color: #444;\n  border: 2px solid rgba(0,0,0,0.3);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.card-image-area img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.card-type-bar {\n  padding: 5px 12px;\n  margin: 6px 8px 0 8px;\n  border-radius: 4px;\n  font-size: 0.8em;\n  font-family: 'Crimson Text', serif;\n  font-weight: 700;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: rgba(0,0,0,0.1);\n  border-top: 1px solid rgba(0,0,0,0.15);\n  border-bottom: 1px solid rgba(0,0,0,0.15);\n}\n.card-body.color-white .card-type-bar { color: #2c2c2c; }\n.card-body:not(.color-white) .card-type-bar { color: #f0f0f0; }\n\n.card-rules-text-box p {\n  margin: 0 0 8px 0;\n}\n.card-rules-text-box p:last-child {\n  margin-bottom: 0;\n}\n.card-flavor-text {\n  font-family: 'Crimson Text', serif;\n  font-style: italic;\n  font-size: 1em;\n  margin-top: 10px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(0,0,0,0.15);\n}\n\n.card-actions {\n  position: absolute;\n  bottom: 15px;\n  right: 15px;\n  display: flex;\n  gap: 8px;\n}\n\n/* Modal styling */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.edit-modal {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n\n@media (max-width: 768px) {\n  .vault-container {\n    padding: 1rem;\n  }\n  \n  .items-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .card-outer-frame {\n    width: 100%;\n    max-width: 320px;\n    margin: 0 auto 1.5rem;\n  }\n}\n\n/* Minimalist theme styles */\n.card-body.minimalist {\n  background: #f9f6ed;\n  border: none;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.card-body.minimalist .card-header-section {\n  background-color: #eee8d8;\n  border-bottom: 1px solid #e0d9c8;\n}\n\n.card-body.minimalist .card-name {\n  color: #000000;\n}\n\n.card-body.minimalist .card-type-bar {\n  background-color: #eee8d8;\n  color: #333333;\n  border-color: #e0d9c8;\n}\n\n.card-body.minimalist .card-rules-text-box {\n  background-color: #f5f1e6;\n  color: #333333;\n  border: 1px solid #e0d9c8;\n}\n\n/* Add card styles */\n.add-card {\n  cursor: pointer;\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.add-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0,0,0,0.3);\n}\n\n.add-card-body {\n  background: #f9f6ed !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.add-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background-color: rgba(0,0,0,0.05);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.add-icon svg {\n  opacity: 0.6;\n}\n\n.add-card:hover .add-icon {\n  background-color: rgba(0,0,0,0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
